import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';

const GridWrapper = ({ children }) => (
	<Grid container justifyContent="center">
		<Grid item md={12} lg={10} sx={{ px: { xs: 5, md: 10 }, py: 8 }}>
			{children}
		</Grid>
	</Grid>
);

GridWrapper.propTypes = {
	children: PropTypes.node.isRequired,
};

export default GridWrapper;
